import { Link } from "react-router-dom";
import { CheckCircle, CreditCard, Lock, ArrowRight, Clock, Monitor, Tag } from "lucide-react";

const C = {
  bg: "#FAFAF8", white: "#FFFFFF", navy: "#1B2A4A",
  gold: "#C9A452", goldLight: "rgba(201,164,82,0.12)", goldBorder: "rgba(201,164,82,0.3)",
  text: "#111827", muted: "#6B7280", border: "#E8E3D8", section: "#F5F2EC",
};

const PROMO = "30 septembre 2026";

const CMA_DATES = [
  { session: "Session Printemps", examen: "29 mai 2026", cloture: "18 avril 2026", statut: "Clôturé" },
  { session: "Session Été", examen: "30 juin 2026", cloture: "22 mai 2026", statut: "Ouvert" },
  { session: "Session Automne", examen: "19 novembre 2026", cloture: "8 octobre 2026", statut: "À venir" },
  { session: "Session Hiver", examen: "28 janvier 2027", cloture: "17 décembre 2026", statut: "À venir" },
];

const PLANS = [
  {
    id: 1, tag: "Formation VTC", title: "Formation VTC",
    prixBarre: "1 490 €", prix: "699 €", highlight: false,
    duration: "7 modules · 2 semaines", mode: "Distanciel",
    features: ["7 modules complets VTC", "Cours du soir en visioconférence", "Coaching personnalisé inclus", "Préparation à l'examen CMA", "Assistance tout au long de la formation"],
    stripeLink: "https://buy.stripe.com/00w3cv6776rE4gn0UudZ605",
    cta: "S'inscrire — 699 €",
  },
  {
    id: 2, tag: "⭐ Plus demandée", title: "Passerelle VTC → Taxi",
    prixBarre: "990 €", prix: "499 €", highlight: true,
    duration: "7 modules · 2 semaines", mode: "Distanciel",
    features: ["7 modules passerelle ciblés", "Cours du soir en visioconférence", "Coaching personnalisé inclus", "Préparation à l'examen CMA", "Paiement sécurisé en ligne"],
    stripeLink: "https://buy.stripe.com/00w3cv6776rE4gn0UudZ605",
    cta: "Payer & S'inscrire — 499 €",
  },
  {
    id: 3, tag: "Formation Taxi", title: "Formation Taxi",
    prixBarre: "1 690 €", prix: "799 €", highlight: false,
    duration: "7 modules · 2 semaines", mode: "Distanciel",
    features: ["7 modules complets Taxi", "Cours du soir en visioconférence", "Coaching personnalisé inclus", "Préparation à l'examen CMA", "Assistance tout au long de la formation"],
    stripeLink: "https://buy.stripe.com/00w3cv6776rE4gn0UudZ605",
    cta: "Payer & S'inscrire — 799 €",
  },
];

function StatusBadge({ s }: { s: string }) {
  const map: Record<string, { bg: string; color: string }> = {
    "Ouvert": { bg: "rgba(22,163,74,0.1)", color: "#15803d" },
    "Clôturé": { bg: "rgba(107,114,128,0.1)", color: "#6B7280" },
    "À venir": { bg: C.goldLight, color: "#92700a" },
  };
  const st = map[s] || map["À venir"];
  return <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: st.bg, color: st.color }}>{s}</span>;
}

export default function Tarifs() {
  return (
    <div style={{ background: C.bg }}>
      {/* Header */}
      <div style={{ background: C.navy, padding: "64px 24px 56px", textAlign: "center" }}>
        <div style={{ display: "inline-block", padding: "4px 14px", borderRadius: 20, background: C.goldLight, border: `1px solid ${C.goldBorder}`, color: C.gold, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 16 }}>Tarifs</div>
        <h1 style={{ fontSize: "clamp(28px, 5vw, 48px)", fontWeight: 700, color: "#fff", marginBottom: 14, fontFamily: "'Playfair Display', serif" }}>
          Tarifs & Paiement sécurisé
        </h1>
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 15, maxWidth: 480, margin: "0 auto 20px" }}>
          3 formations à prix promotionnels · Paiement en ligne sécurisé par carte bancaire
        </p>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 18px", borderRadius: 10, background: C.goldLight, border: `1px solid ${C.goldBorder}`, color: C.gold, fontWeight: 700, fontSize: 14 }}>
          <Tag size={15} /> ⚡ Prix en promotion jusqu'au {PROMO}
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "56px 24px" }}>
        {/* Grille tarifs */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 24, marginBottom: 40 }}>
          {PLANS.map((p) => (
            <div key={p.id} style={{ borderRadius: 20, border: `1px solid ${p.highlight ? C.gold : C.border}`, background: p.highlight ? "#FFFDF6" : C.white, display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: p.highlight ? `0 8px 32px ${C.goldLight}` : "0 2px 12px rgba(27,42,74,0.05)" }}>
              {p.highlight && (
                <div style={{ background: C.gold, color: C.navy, textAlign: "center", fontSize: 12, fontWeight: 800, padding: "8px 0", letterSpacing: "0.06em" }}>
                  ⭐ FORMATION LA PLUS DEMANDÉE
                </div>
              )}
              <div style={{ padding: "28px 24px 16px" }}>
                <div style={{ display: "inline-block", padding: "3px 11px", borderRadius: 20, marginBottom: 12, fontSize: 11, fontWeight: 700, textTransform: "uppercase" as const, background: p.highlight ? C.goldLight : C.section, color: p.highlight ? "#92700a" : C.muted }}>
                  {!p.highlight ? p.tag : "Passerelle"}
                </div>
                <h2 style={{ fontSize: 20, fontWeight: 700, color: C.navy, marginBottom: 4, fontFamily: "'Playfair Display', serif" }}>{p.title}</h2>
                <div style={{ margin: "16px 0" }}>
                  <div style={{ fontSize: 13, color: C.muted, textDecoration: "line-through", marginBottom: 2 }}>Tarif moyen constaté : {p.prixBarre}</div>
                  <div style={{ fontSize: "clamp(34px, 5vw, 46px)", fontWeight: 800, color: C.navy, lineHeight: 1, fontFamily: "'Playfair Display', serif" }}>{p.prix}</div>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 4, marginTop: 6, padding: "3px 10px", borderRadius: 20, background: C.goldLight, border: `1px solid ${C.goldBorder}`, color: "#92700a", fontSize: 11, fontWeight: 700 }}>
                    <Tag size={9} /> Promo jusqu'au {PROMO}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
                  <span style={{ fontSize: 12, color: C.muted, display: "flex", alignItems: "center", gap: 5 }}><Clock size={12} color={C.navy} /> {p.duration}</span>
                  <span style={{ fontSize: 12, color: C.muted, display: "flex", alignItems: "center", gap: 5 }}><Monitor size={12} color={C.navy} /> {p.mode}</span>
                </div>
                <ul style={{ listStyle: "none", padding: 0, margin: "0 0 8px", display: "flex", flexDirection: "column", gap: 8 }}>
                  {p.features.map((f) => (
                    <li key={f} style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, color: C.text }}>
                      <CheckCircle size={14} color={p.highlight ? C.gold : "#16a34a"} style={{ flexShrink: 0, marginTop: 1 }} /> {f}
                    </li>
                  ))}
                </ul>
                <div style={{ fontSize: 12, color: "#92700a", padding: "7px 10px", borderRadius: 8, background: C.goldLight, marginTop: 8 }}>⚠️ + Frais d'examen CMA à prévoir en sus</div>
              </div>
              <div style={{ padding: "0 24px 24px", marginTop: "auto", display: "flex", flexDirection: "column", gap: 10 }}>
                {p.stripeLink ? (
                  <a href={p.stripeLink} target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "14px", borderRadius: 10, background: p.highlight ? C.gold : C.navy, color: p.highlight ? C.navy : "#fff", fontWeight: 700, fontSize: 14, textDecoration: "none", boxShadow: `0 6px 20px rgba(27,42,74,0.16)` }}>
                    <CreditCard size={15} /> {p.cta}
                  </a>
                ) : (
                  <Link to="/contact" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "14px", borderRadius: 10, background: "transparent", color: C.navy, border: `1px solid ${C.navy}`, fontWeight: 700, fontSize: 14, textDecoration: "none", boxSizing: "border-box" as const }}>
                    {p.cta} <ArrowRight size={15} />
                  </Link>
                )}
                <a href="https://wa.me/33749124282" target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "11px", borderRadius: 10, background: "rgba(22,163,74,0.08)", border: "1px solid rgba(22,163,74,0.25)", color: "#15803d", fontWeight: 600, fontSize: 13, textDecoration: "none" }}>
                  💬 Inscription via WhatsApp
                </a>
                {p.stripeLink && <div style={{ textAlign: "center", fontSize: 11, color: C.muted, display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}><Lock size={10} /> Paiement sécurisé · Stripe</div>}
              </div>
            </div>
          ))}
        </div>

        {/* Stripe */}
        <div style={{ borderRadius: 14, padding: "20px 24px", background: C.section, border: `1px solid ${C.border}`, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 18, marginBottom: 48 }}>
          <div style={{ width: 40, height: 40, borderRadius: 10, background: C.navy, display: "flex", alignItems: "center", justifyContent: "center" }}><CreditCard size={18} color="#fff" /></div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, color: C.navy, fontSize: 14, marginBottom: 3 }}>Paiement 100% sécurisé avec Stripe</div>
            <div style={{ color: C.muted, fontSize: 13 }}>Visa, Mastercard, AMEX · Lien de paiement envoyé après validation du dossier · SSL 256 bits</div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            {["VISA", "MC", "AMEX"].map((c) => (
              <div key={c} style={{ padding: "4px 10px", borderRadius: 6, background: C.white, border: `1px solid ${C.border}`, color: C.muted, fontSize: 11, fontWeight: 700 }}>{c}</div>
            ))}
          </div>
        </div>

        {/* Dates CMA */}
        <div style={{ marginBottom: 48 }}>
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <div style={{ display: "inline-block", padding: "4px 14px", borderRadius: 20, background: C.goldLight, border: `1px solid ${C.goldBorder}`, color: "#92700a", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 14 }}>
              Calendrier officiel CMA IDF
            </div>
            <h2 style={{ fontSize: "clamp(20px, 3vw, 30px)", fontWeight: 700, color: C.navy, marginBottom: 8, fontFamily: "'Playfair Display', serif" }}>
              Sessions Examen CMA Île-de-France 2026–2027
            </h2>
            <p style={{ color: C.muted, fontSize: 14 }}>Examens Taxi & VTC — Inscrivez-vous avant la date de clôture</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16 }}>
            {CMA_DATES.map((d) => (
              <div key={d.session} style={{ borderRadius: 14, padding: "22px 18px", background: C.white, border: `1px solid ${d.statut === "Ouvert" ? C.gold : C.border}`, boxShadow: d.statut === "Ouvert" ? `0 4px 20px ${C.goldLight}` : "none", position: "relative" }}>
                {d.statut === "Ouvert" && (
                  <div style={{ position: "absolute", top: -10, left: "50%", transform: "translateX(-50%)", padding: "3px 12px", borderRadius: 20, background: C.gold, color: C.navy, fontSize: 10, fontWeight: 800, whiteSpace: "nowrap" }}>
                    ⚡ Inscription ouverte
                  </div>
                )}
                <div style={{ marginBottom: 10 }}><StatusBadge s={d.statut} /></div>
                <div style={{ fontWeight: 700, fontSize: 12, color: C.navy, marginBottom: 12, textTransform: "uppercase", letterSpacing: "0.06em" }}>{d.session}</div>
                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 10, color: C.muted, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 2 }}>Date d'examen</div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: C.navy }}>{d.examen}</div>
                </div>
                <div>
                  <div style={{ fontSize: 10, color: C.muted, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 2 }}>Clôture inscriptions</div>
                  <div style={{ fontWeight: 600, fontSize: 13, color: d.statut === "Ouvert" ? "#dc2626" : C.muted }}>{d.cloture}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 20, padding: "14px 20px", borderRadius: 10, background: "rgba(220,38,38,0.06)", border: "1px solid rgba(220,38,38,0.18)", textAlign: "center" }}>
            <span style={{ color: "#dc2626", fontSize: 13, fontWeight: 700 }}>⚠️ DERNIÈRE SESSION avant pause estivale — Clôture des inscriptions : <strong>22 mai 2026</strong></span>
          </div>
        </div>

        {/* Financement */}
        <div>
          <h2 style={{ fontSize: 24, fontWeight: 700, color: C.navy, textAlign: "center", marginBottom: 28, fontFamily: "'Playfair Display', serif" }}>Modes de financement</h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16 }}>
            {[
              
              
              
              { icon: "💳", title: "Paiement direct", desc: "CB sécurisée via Stripe · Lien envoyé par WhatsApp" },
            ].map((fn) => (
              <div key={fn.title} style={{ borderRadius: 14, padding: 20, background: C.white, border: `1px solid ${C.border}` }}>
                <div style={{ fontSize: 26, marginBottom: 10 }}>{fn.icon}</div>
                <div style={{ fontWeight: 700, fontSize: 14, color: C.navy, marginBottom: 6 }}>{fn.title}</div>
                <div style={{ color: C.muted, fontSize: 12, lineHeight: 1.6 }}>{fn.desc}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: 40 }}>
          <Link to="/contact" style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "13px 28px", borderRadius: 10, background: C.navy, color: "#fff", fontWeight: 700, fontSize: 14, textDecoration: "none", boxShadow: "0 6px 20px rgba(27,42,74,0.2)" }}>
            Nous contacter <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </div>
  );
}
